import _implicitStylesheets from "./listingDetailWrapper.css";
import _implicitScopedStylesheets from "./listingDetailWrapper.scoped.css?scoped=true";
import _pagesListingDetailV2 from "pages/listingDetailV2";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  key: 0
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element} = $api;
  return [api_custom_element("pages-listing-detail-v2", _pagesListingDetailV2, stc0)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-46l1kgs8jr6";
tmpl.legacyStylesheetToken = "undefined-_listingDetailWrapper";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
